import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "kt_app_toolbar",
  class: "app-toolbar py-3 py-lg-6"
}
const _hoisted_2 = { class: "d-flex align-items-center py-3 py-md-1" }

import { toolbarWidthFluid } from "@/core/helpers/config";
import SalesSelector from "@/projects/client/modules/sales/components/SalesSelector.vue";
import RepSelector from "@/projects/client/modules/rep/components/RepSelector.vue";
// import IBSelector from "@/projects/client/modules/ib/components/IBSelector.vue";
// import TradeSelector from "@/projects/client/modules/reports/components/TradeSelector.vue";
import KTPageTitle from "@/layouts/client-layout/toolbar/PageTitle.vue";
import IBSelector from "@/projects/client/modules/ib/components/IBSelector.vue";
import { isMobile } from "@/core/config/WindowConfig";

const __default__ = {
  name: "layout-toolbar",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {

__expose({
  // showIBSelector: (isShow: boolean) => (isShowIbSelector.value = isShow),
  // showSalesSelector: (isShow: boolean) => (isShowSalesSelector.value = isShow),
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      id: "kt_app_toolbar_container",
      class: _normalizeClass(["app-container", [
        {
          'container-fluid': _unref(toolbarWidthFluid),
          'container-xxl': !_unref(toolbarWidthFluid),
        },
        _unref(isMobile) ? '' : 'd-flex flex-stack',
      ]])
    }, [
      _createVNode(KTPageTitle),
      _createElementVNode("div", _hoisted_2, [
        (_ctx.$can('Sales'))
          ? (_openBlock(), _createBlock(SalesSelector, { key: 0 }))
          : _createCommentVNode("", true),
        (_ctx.$can('IB'))
          ? (_openBlock(), _createBlock(IBSelector, { key: 1 }))
          : _createCommentVNode("", true),
        (_ctx.$can('Rep'))
          ? (_openBlock(), _createBlock(RepSelector, { key: 2 }))
          : _createCommentVNode("", true)
      ])
    ], 2)
  ]))
}
}

})